import styled from "@emotion/styled";
import {Bindings} from "data/constants/bindings";
import {useViewController} from "data/services/locator";
import React from "react";
import {observer} from "mobx-react";
import {Exist} from "views/components/exist/exist.component";
import {ISharingController} from "views/components/sharing/sharing.controller";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import {useIsMobile} from "data/hooks";
import {ShareRounded} from "@mui/icons-material";
import {ButtonPrimary} from "views/components/buttons/buttons.component";
import {ShareType} from "data/enums";
import {Box} from "@mui/material";

const Wrapper = styled.div`
	position: relative;
	width: 100%;
	display: flex;
	flex-flow: column;
	gap: 8px;

	> button {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 4px;
	}
`;

const ButtonRow = styled(Box)`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: row;
	gap: 12px;
	width: 100%;
	button {
		min-width: 0;
		max-width: 300px;
	}

	@media (max-width: 470px) {
		flex-flow: column;
	}
`;

interface IProps {
	imageUrl?: string;
	shareType: ShareType;
	contestId: number;
	shareMessage?: string;
	nativeTitle?: string;
	buttonText?: string;
}

export const Sharing: React.FC<IProps> = observer(
	({imageUrl = "", shareType, contestId, shareMessage = "", nativeTitle = "", buttonText}) => {
		const {isMobileShare, isMobile} = useIsMobile();

		const {i18n, shareFacebook, shareTwitter, shareNative} =
			useViewController<ISharingController>(Bindings.SharingController, {
				imageUrl,
				shareType,
				contestId,
				shareMessage,
				nativeTitle,
			});

		return (
			<Wrapper>
				<Exist when={isMobileShare}>
					<ButtonPrimary variant="contained" onClick={shareNative} fullWidth={true}>
						<span style={{marginRight: 8, display: "flex", alignItems: "center"}}>
							{buttonText || i18n.t("modal.confirm.share", "Share Vote")}
						</span>
						<ShareRounded />
					</ButtonPrimary>
				</Exist>
				{/*Hide FB / X on desktop per F2P1-40185*/}
				<Exist when={!isMobileShare && isMobile}>
					<ButtonRow>
						<ButtonPrimary variant="contained" onClick={shareFacebook} fullWidth={true}>
							<span>{i18n.t("sharing.copy.facebook", "Facebook")}</span>
							<FacebookIcon />
						</ButtonPrimary>
						<ButtonPrimary variant="contained" onClick={shareTwitter} fullWidth={true}>
							<XIcon />
						</ButtonPrimary>
					</ButtonRow>
				</Exist>
			</Wrapper>
		);
	}
);
